<template>
  <div class="course-wrapper" :class="{'float': isViewFloat}">
    <!-- <Header></Header> -->
    <div class="course-container">
      <div class="course-header" :class="{'float': isViewFloat}">
        <div class="course-search" :class="{'float': isViewFloat}" @click="toSearch">
          <icon icon-class="search"></icon>搜索
        </div>
      </div>
      <div class="course-list-swiper" id="listSwiper">
        <div class="list-wrapper">
          <studio-card :item="item" v-for="item in studioList" :key="item.id"></studio-card>
        </div>
        <!-- <div class="swiper-wrapper">
          <div class="swiper-slide">
            <scroll-view ref="scrollView" :name="'workshop'" @scroll="listScrollAction" v-if="workshopList.length > 0">
              <div class="list-wrapper">
                <workshop-card :item="item" v-for="item in workshopList" :key="item.id"></workshop-card>
              </div>
            </scroll-view>
          </div>
          <div class="swiper-slide">
            <scroll-view ref="scrollView" :name="'studio'" @scroll="listScrollAction" v-if="studioList.length > 0">
              <div class="list-wrapper">
                <studio-card :item="item" v-for="item in studioList" :key="item.id"></studio-card>
              </div>
            </scroll-view>
          </div>
          <div class="swiper-slide">
            <scroll-view ref="scrollView" :name="'publicClass'" @scroll="listScrollAction" v-if="publicClassList.length > 0">
              <div class="list-wrapper">
                <public-class-card :item="item" v-for="item in publicClassList" :key="item.id"></public-class-card>
              </div>
            </scroll-view>
          </div>
          <div class="swiper-slide">
            <scroll-view ref="scrollView" :name="'oneonone'" @scroll="listScrollAction">
              <oneonone @update="updateScrollView"></oneonone>
            </scroll-view>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
  .course-wrapper{
    // height: calc(~"100vh - 87px");
    // overflow: hidden;
    background: #F8F8F8;
    transition: background .2s;
    &.float{
      background: #FFF;
    }
    .course-container{
      display: flex;
      flex-direction: column;
      margin: 0;
      height: 100%;
      width: 100%;
      position: relative;
      .course-header{
        padding-top: 8px;
        flex-shrink: 0;
        transition: margin .5s;
        &.float{
          margin-top: -158px;
        }
        .course-swiper{
          height: 150px;
          margin: 0 12px;
          .course-item{
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 6px;
            overflow: hidden;
            .cover{
              width: 100%;
              img{
                width: 100%;
              }
            }
            .info{
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 46%, rgba(0, 0, 0, 0.7) 100%);
              border-radius: 6px;
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              align-items: flex-start;
              .type{
                margin-left: 12px;
                padding: 0 4px;
                color: #FFF;
                background: linear-gradient(270deg,rgba(130,70,239,1) 0%,rgba(217,103,235,1) 100%);
                font-size: 12px;
                height: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 2px;
                margin-bottom: 4px;
                &.workshop{
                  background: linear-gradient(270deg,rgba(43,124,235,1) 0%,rgba(88,186,234,1) 100%);
                }
                &.studio{
                  background: linear-gradient(270deg,rgba(130,70,239,1) 0%,rgba(217,103,235,1) 100%);
                }
                &.article{
                  background: linear-gradient(90deg,rgba(250,200,87,1) 0%,rgba(245,156,57,1) 100%);
                }
              }
              .title{
                margin-left: 12px;
                font-size: 14px;
                line-height: 22px;
                color: #FFF;
                font-weight: bold;
                margin-bottom: 18px;
              }
            }
          }
        }
        .course-search{
          margin: 10px 12px 0;
          height: 36px;
          border-radius: 36px;
          box-shadow: 0px 2px 8px 0px rgba(77, 162, 199, 0.05);
          background: #FFF;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: #999;
          font-size: 14px;
          padding: 0 12px;
          transition: background .2s;
          svg{
            font-size: 16px;
            margin-right: 10px;
          }
          &.float{
            background: #F3F3F3;
            box-shadow: none;
          }
        }
        .course-type-tab{
          position: relative;
          box-sizing: border-box;
          display: flex;
          justify-content: space-around;
          align-items: flex-end;
          width: 100%;
          font-size: 14px;
          color: #666;
          background-color: #fff;
          transition: all .3s ease;
          padding: 16px 0 5px;
          border-radius: 12px 12px 0 0;
          margin-top: 12px;
          .tab-item{
            width: 25%;
            text-align: center;
            height: 24px;
            line-height: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all .2s;
            &.active{
              color: #333;
              font-weight: bold;
            }
          }
          .active-line{
            position: absolute;
            top: calc(~"100% - 3px");
            width: 24px;
            height: 3px;
            background-color: @cano;
            border-radius: 3px;
            transition: all .3s ease;
            transform: translateX(-50%);
          }
        }
      }
    }
  }
  .course-list-swiper{
    flex: 1;
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // background: #FFF;
    height: 0;
    .list-wrapper{
      padding: 12px 12px 0;
    }
  }
</style>

<style lang="less">
  .swiper-pagination.swiper-pagination-bullets{
    width: auto;
    right: 12px;
    bottom: 9px;
    left: auto;
    .swiper-pagination-bullet{
      width: 6px;
      height: 3px;
      background: rgba(255,255,255,.5);
      border-radius: 2px;
      margin: 0;
      margin-left: 2px!important;
      transition: all .2s;
      &.swiper-pagination-bullet-active{
        background: #FFF;
        width: 13px;
      }
    }
  }
</style>

<script>
  import Swiper, { Navigation, Pagination } from 'swiper'
  import Header from '@/components/Common/header.vue'
  import ScrollView from '@/components/Common/scrollView.vue'
  import WorkshopCard from '@/components/Course/Cards/workshopCard'
  import StudioCard from '@/components/Course/Cards/studioCard'
  import PublicClassCard from '@/components/Course/Cards/publicClassCard'
  import Oneonone from '@/components/Course/oneonone';
  export default {
    data() {
      return {
        currentPage: 1,
        // tab-item的下划线位置
        navArr: [12.5, 37.5, 62.5, 87.5],
        navLeft: 12.5,
        swiperCourseData: [],
        courseSwiper: null,
        listSwiper: null,
        isViewFloat: false,
        // 小组课
        workshopList: [],
        // 设计室
        studioList: [],
        // 公开课
        publicClassList: [],
      }
    },
    components: {
      Header,
      ScrollView,
      WorkshopCard,
      StudioCard,
      PublicClassCard,
      Oneonone
    },
    created() {
      this.$store.commit('setActiveMenu', 'course');
      this.getStudio(1);
      // this.$root.post('/Public/get_index_class').then(data => {
      //   this.swiperCourseData = data || [];
      //   this.getWorkshop();
      //   this.$nextTick(() => {
      //     this.courseSwiper = new Swiper('#courseSwiper', {
      //       pagination: {
      //         el: '.swiper-pagination',
      //         clickable: true,
      //       },
      //     });
      //     let _this = this;
      //     this.listSwiper = new Swiper('#listSwiper', {
      //       noSwiping: true,
      //       noSwipingSelector: '.on-swipeing',
      //       on: {
      //         slideChange() {
      //           _this.currentPage = this.activeIndex;
      //           _this.navLeft = _this.navArr[this.activeIndex];
      //           _this.pageDataLoad();
      //         }
      //       }
      //     });
      //   })
      // })
    },
    mounted() {
      Swiper.use([Navigation, Pagination]);
    },
    methods: {
      // 列表滚动时判断刷新页面组件状态
      listScrollAction(pos) {
        if((pos.y < -10 && this.isViewFloat) || (pos.y > -10 && !this.isViewFloat)) return;
        this.isViewFloat = pos.y < -10 ? true : false;
        this.listSwiper.update();
        // setTimeout(() => {
        //   this.$refs.scrollView.refresh();
        // }, 600);
      },
      updateScrollView() {
        // console.log('update')
        this.$refs.scrollView.refresh();
      },
      // 顶部推荐课程跳转
      toCourseDetail(item) {
        switch(parseInt(item.type)) {
          case 1: {
            // 设计室
            this.$router.push({name: 'studioDetail', params: {id: item.id}});
          };break;
          case 2: {
            // 小组课
            // window.open(`/public/index#/course/workshop/id/${item.id}`, '_blank');
            this.$router.push({name: 'workshopDetail', params: {id: item.id}});
          };break;
          case 3: {
            // 干货
            window.open(`/article/detail/id/${item.id}`, '_blank');
          };break;
        }
      },
      switchPage(index) {
        this.currentPage = index;
        this.navLeft = this.navArr[index];
        this.listSwiper.slideTo(index);
      },
      // 页面切换时加载数据的逻辑
      pageDataLoad() {
        if (this.currentPage == 1 && this.studioList.length == 0) {
          this.getStudio(1);
        } else if (this.currentPage == 2 && this.publicClassList.length == 0) {
          this.getPublicCourse(1);
        } else if (this.currentPage == 3) {
          this.$nextTick(() => {
            this.updateScrollView();
          })
        } else {
          // 不用加载
        }
      },
      // 获取小组课
      getWorkshop(page, cb, more = false) {
        this.$root.post('/Course/get_workshop_list', {
          page: 1,
          count: 9999,
        }).then(data => {
          console.log(data);
          this.workshopList = data.info || [];
        })
      },
      // 获取设计室
      getStudio(page, cb, more = false) {
        this.$root.post('/Course/get_studio_list', {
          page: 1,
          count: 9999,
        }).then(data => {
          console.log(data);
          this.studioList = data.info || [];
        })
      },
      getPublicCourse(page, cb, more = false) {
        this.$root.post('/Course/get_openlecture_list', {
          page: 1,
          count: 9999,
        }).then(data => {
          console.log(data);
          this.publicClassList = data.info || [];
        })
      },
      // 搜索页面
      toSearch() {
        this.$router.push({path: '/search', query: {type: this.currentPage}})
      }
    },
    filters: {
      TypeFilter(value, classType) {
        if(classType) {
          switch(value) {
            case '1': return 'studio';break;
            case '2': return 'workshop';break;
            case '3': return 'article';break;
          }
        }else {
          switch(value) {
            case '1': return '设计室开题';break;
            case '2': return '小组课新课上线';break;
            case '3': return '干货文章';break;
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Course/index.vue